export const getValidationGenerarCadenaModal = () => {
  return {
    generarCadenaModal: {
      tipo_cadena: [{ required: true, message: 'Tipo de Cadena es requerido.' }],
    },
  }
}
